import React from 'react'
import PropTypes from 'prop-types'
import { InputField, InputSelectOptions, LoaderButton } from 'components/molecules'
import { Form, Formik } from 'formik'
import fastSellProductRejectFormInitialValues from './fast-sell-product-reject-form-initial-values'
import fastSellProductRejectFormSchema from './fast-sell-product-reject-form-schema'
import { REJECT_LABEL } from 'domains/fast-sell-product/constants'
import { CardLoader } from 'components/organisms'
import withLoader from 'hocs/with-loader'


const propTypes = {
  fastSellProduct: PropTypes.shape({
    id                   : PropTypes.number,
    status_reject_reason : PropTypes.string,
    ops_notes            : PropTypes.string
  }),
  onClickSubmit : PropTypes.func,
  formClassName : PropTypes.string
}

const defaultProps = {
  fastSellProduct : {},
  onClickSubmit   : () => { },
  formClassName   : ''
}

const FastSellProductRejectForm        = ({
  onClickSubmit,
  fastSellProduct,
  formClassName
}) => (
  <Formik
    initialValues={ fastSellProductRejectFormInitialValues(fastSellProduct) }
    enableReinitialize={ true }
    validationSchema={ fastSellProductRejectFormSchema }
    onSubmit={ onClickSubmit }
  >
    {
      (formik) => (
        <Form className={ formClassName }>
          <InputField
            type={ 'text' }
            formGroupClassName={ 'm-2' }
            name={ 'ops_notes' }
            label={ 'Internal Notes' }
            formText={
              'Alasan mengapa barang di reject secara deskriptif, Untuk internal Tinkerlust'
            }
          />
          <InputField
            type={ 'select' }
            formGroupClassName={ 'm-2 text-nowrap' }
            name={ 'status_reject_reason' }
            label={ 'Reject Reason' }
            formText={ 'Alasan mengapa barang di reject' }
          >
            <InputSelectOptions
              options={ REJECT_LABEL }
            />
          </InputField>
          <div className='text-right'>
            <LoaderButton
              color='danger'
              type='submit'
              disabled={ formik.isSubmitting }
              isLoading={ formik.isSubmitting }
              text='Reject'
            />
          </div>
        </Form>
      )
    }
  </Formik>
)
FastSellProductRejectForm.propTypes    = propTypes
FastSellProductRejectForm.defaultProps = defaultProps

export default withLoader(FastSellProductRejectForm, CardLoader)
